
import React from 'react';
import MainLayout from '../../../layouts/MainLayout';
import { Link } from 'react-router-dom';
import '../styles/Thinkletics.css';

const AboutThinkletics = () => {
    return (
        <MainLayout>
            <div className="min-h-full py-8 bg-gradient-to-r from-blue-300 via-blue-400 to-blue-500 mt-8">
                <h2 className='text-3xl font-bold text-white text-center mb-6'>Thinkletics</h2>
                <div className="main-content text-white ml-4 mr-4 border border-gray-200 text-sm">
                    <header className='mt-4'>
                        <h2 className="h2 bg-yellow-500 text-white text-center">Thinkletics: The International Competition</h2>
                        <p className="text-lg text-yellow-300 text-center">For everybody from Students to Scientists, Workers to CEOs who are Deep Thinkers & Intellectual</p>
                        <p className="mt-4 text-xl  bg-purple-500 text-white text-center"><strong>Thinkletics@Think5Whys – where deep thinkers become intellectual.</strong></p>
                    </header>

                    <section className="section">
                        <h2 className="h2">Welcome</h2>
                        <p>Welcome to Thinkletics, where the world's sharpest minds converge for a unique blend of deep thinking and competitive challenges.</p>
                    </section>

                    <section className="section">
                        <h2 className="h2">About the Competition</h2>
                        <p>This annual international competition celebrates intellectual prowess and mental agility, fostering a spirit of innovation and excellence.</p>
                        <p>Join us in a series of thought-provoking activities designed to test and expand your cognitive abilities, and compete with like-minded people from around the globe.</p>
                        <p><strong>Thinkletics is an Annual Competition</strong></p>
                    </section>

                    <section className="section">
                        <h2 className="h2">Rewards</h2>
                        <p>Winner, first runner up & second runner up will get cash rewards (direct transfer), medals & certificates (eCertificates) both will be delivered to winners' addresses.</p>
                        <p>Top 1% of participants qualified for Thinkletics will be awarded with Thinkletics: IMDeepThinker eCertificate.</p>
                        <p>All participants qualified for Thinkletics will be awarded with Thinkletics Participants eCertificate.</p>
                    </section>

                    <section className="section">
                        <h2 className="h2">Event Categories</h2>
                        <h3 className="h3">Open Event - Country or Region Specific</h3>
                        <p>Examples:</p>
                        <ul className="ul">
                            <li>International Thinkletics</li>
                            <li>Indian Thinkletics</li>
                            <li>Dubai Thinkletics</li>
                            <li>GCC Thinkletics</li>
                            <li>European Thinkletics</li>
                            <li>Asia-Pacific Thinkletics</li>
                            <li>Maharashtra Thinkletics</li>
                        </ul>
                        <h3 className="h3">Institutional / Sponsored Event - Company Specific</h3>
                        <p>Examples:</p>
                        <ul className="ul">
                            <li>"My Corporate" Thinkletics</li>
                            <li>"My Bank" Thinkletics</li>
                            <li>"My State Government" Thinkletics</li>
                            <li>"My Central Government" Thinkletics</li>
                            <li>"My School"S Thinkletics</li>
                        </ul>
                    </section>

                    <section className="section">
                        <h2 className="h2">Participant Categories</h2>
                        <h3 className="h3">Open Categories</h3>
                        <ul className="ul">
                            <li>School</li>
                            <li>Undergraduate</li>
                            <li>Post Graduate</li>
                        </ul>
                        <h3 className="h3">Institutional / Sponsored Categories</h3>
                        <ul className="ul">
                            <li>Workers</li>
                            <li>Executives</li>
                            <li>Managers</li>
                        </ul>
                    </section>

                    <section className="section">
                        <h2 className="h2">Event Categories</h2>
                        <ul className="ul">
                            <li>Singles</li>
                            <li>Pair</li>
                            <li>Team</li>
                        </ul>
                    </section>

                    <section className="section">
                        <h2 className="h2">How to Earn Points?</h2>
                        <ol className="ol">
                            <li> 1. <Link to="/bookworld" className=' text-yellow-200 hover:bg-slate-400 w-full'>Think5Whys Collection 1 Purchase</Link></li>
                            <li> 2. <Link to="/thinkleticsdashboard" className=' text-yellow-200 hover:bg-slate-400 w-full'>Enrollment / Actiavtion for the Competition as Single Participant</Link></li>
                            <li> 3. <Link to="/assignments-think5whys" className=' text-yellow-200 hover:bg-slate-400 w-full'>Online DIY Assignments</Link></li>
                            <li> 4. <Link to="/practice-mcq" className=' text-yellow-200 hover:bg-slate-400 w-full'>MCQ Practice</Link></li>
                            <li> 5. <Link to="/certification-test-think5whys" className=' text-yellow-200 hover:bg-slate-400 w-full'>Certification Test</Link></li>
                            <li> 6. <Link to="/thinkleticsdashboard" className=' text-yellow-200 hover:bg-slate-400 w-full'>Event Registration</Link></li>
                            <li> 7. <Link to="/rcas/add" className=' text-yellow-200 hover:bg-slate-400 w-full'>Think5whys RCA Data Entry</Link></li>
                            <li> 8. <Link to="/tasks/add" className=' text-yellow-200 hover:bg-slate-400 w-full'>Think5Whys Life Chronicles Data Entry</Link></li>
                            <li> 9. Each <Link to="/rcas/add" className=' text-yellow-200 hover:bg-slate-400 w-full'>RCA</Link> & <Link to="/rcas/add" className=' text-yellow-300 hover:bg-slate-400 w-full'>Life Chronicle Linking</Link></li>
                            <li>10. <Link to="/bookworld" className=' text-yellow-200 hover:bg-slate-400 w-full'>Think5Whys Book Every Unique Page Read</Link></li>
                            <li>11. <Link to="/spotsnap" className=' text-yellow-200 hover:bg-slate-400 w-full'>SpotSnap Entry</Link></li>
                            <li>12. <Link to="/focus-timer-home" className=' text-yellow-200 hover:bg-slate-400 w-full'>Focus Timer 25 minutes Pomodoro</Link></li>
                            <li>13. <Link to="/visualbrief-home" className=' text-yellow-200 hover:bg-slate-400 w-full'>Visual Brief Presentations</Link></li>
                            <li>14. <Link to="/povify-home" className=' text-yellow-200 hover:bg-slate-400 w-full'>POV (Point of View) Creation & Comment</Link></li>
                            <li>15. <Link to="/bookworld" className=' text-yellow-200 hover:bg-slate-400 w-full'>Book / Program / Course Buyings from Think5Whys BookWorld</Link></li>
                            <li>16. <Link to="/assignments-think5whys" className=' text-yellow-200 hover:bg-slate-400 w-full'>Think5Whys Program Gifting</Link></li>
                        </ol>
                    </section>

                    <section className="section">
                        <h2 className="h2">Terms & Conditions Apply</h2>
                    </section>
                </div>
            </div>
        </MainLayout>
    );
};

export default AboutThinkletics;
